import React from 'react'
import { Button, List, ListItemText, ListItem, ListItemIcon, Typography, Box } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import roteirizacaoGIF from '../../../../../images/roteirizacao-gif.gif'
import ContainerBox from '@/components/shared/boxes/ContainerBox'



const Paywall: React.FC = () => {

    const contactIntercom = () => {
        Intercom(
            'showNewMessage',
            'Olá! Quero entender melhor como funciona a Roteirização Inteligente do Produttivo.'
        )
    }

    return(

        <Box data-testid="paywall-content-box" sx={{ bgcolor: 'background.default' }}>
            <ContainerBox sx={{ display: 'flex', flexDirection: 'column', gap: '3.25rem' }}>
                <Box
                    sx={{
                        display: 'flex', flexDirection: 'column',flexWrap: 'wrap' , height:'100%'
                    }} 
                >
                    <Box sx={{height: '10%', display:'flex', alignItems:'center'}}>
                        <Typography variant='h4' color='primary' >
                            O Produttivo cria as melhores rotas para sua rotina
                        </Typography>
                    </Box>
                
                    <Box 
                        sx={{
                        display: 'flex',
                        height: '90%',
                        justifyContent:'space-around'
                        }} 
                    >
                        <Box 
                        sx={{
                            width:'60%',
                            display: 'flex',
                            flexDirection:'column',
                            justifyContent: 'space-evenly'
                        }}
                        >
                            <Typography
                                variant='body1'
                            >
                                A Roteirização Inteligente do Produttivo usa inteligência artificial para gerar automaticamente as melhores rotas para você, considerando:
                            </Typography>
                            <List>
                                <ListItem>
                                <ListItemIcon sx={{ minWidth: '30px' }}>
                                    <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                </ListItemIcon>
                                <ListItemText primary="Tempo de deslocamento" />
                                </ListItem>
                                <ListItem>
                                <ListItemIcon sx={{ minWidth: '30px' }}>
                                    <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                </ListItemIcon>
                                <ListItemText primary="Localização dos serviços " />
                                </ListItem>
                                <ListItem>
                                <ListItemIcon sx={{ minWidth: '30px' }}>
                                    <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                </ListItemIcon>
                                <ListItemText primary="Atendimentos atribuídos a cada técnico" />
                                </ListItem>

                            </List>
                            <Typography
                                variant='body1'
                            >
                                Você ganha <b>agilidade</b> no planejamento, <b>evita reagendamentos</b> e <b>conclui mais atendimentos</b> no mesmo dia, com <b>economia</b> de esforço na gestão, tempo e combustível.
                            </Typography>
                            <Typography>
                                Te mostramos ao lado como funciona!
                            </Typography>


                            <Box sx={{display: 'flex', gap:'1rem', alignItems:'center'}}>
                                <Button 
                                    variant="contained" 
                                    size="medium"
                                    onClick={contactIntercom}
                                > 
                                    Falar com um consultor
                                </Button>

                                <Typography
                                    component='a'
                                    href='https://help.produttivo.com.br/pt-BR/articles/14841240-roteirizacao-inteligente-as-melhores-rotas-para-concluir-mais-servicos-e-evitar-reagendamentos'
                                    target='_blank' 
                                    rel='noopener noreferrer'
                                    sx={{ 
                                        textDecoration: 'none', 
                                        color: 'inherit',       
                                        cursor: 'pointer',
                                        '&:hover':{
                                        textDecoration: 'underline',
                                        color: '#333333'
                                        
                                        }
                                    }}
                                    >
                                    Saiba mais
                                </Typography>
                            </Box>
                        </Box>
                    
                    <Box sx={{maxWidth:'40%',display: 'flex', flexDirection: 'column',justifyContent:'center',alignItems: 'center'}}>
                        <Box 
                            component='img' 
                            sx={{height:'100%', width:'auto'}}
                            src={roteirizacaoGIF}
                            alt='Demonstração de roteirização'
                            
                        />
                    </Box>
                </Box>
                </Box>
            </ContainerBox >
        </Box>


    )
}

export default Paywall